import React, { Component } from "react";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl, { FormControlProps } from "@material-ui/core/FormControl";
import InputLabel, { InputLabelProps } from "@material-ui/core/InputLabel";
import ReactDatePicker, { ReactDatePickerProps } from "./ReactDatePicker";
import moment from "moment";
import { pick } from "@bonliva-crm/common";

export type DatePickerProps = Pick<
  FormControlProps,
  "error" | "required" | "onBlur" | "style" | "classes" | "fullWidth" | "className"
> &
  Omit<ReactDatePickerProps, "placeholderText"> & {
    label?: string;
    placeholder?: string;
    withLabel?: boolean;
    withTime?: boolean;
    innerRef?: ((ref: any) => any) | React.MutableRefObject<any>;
    helperText?: string;
    InputLabelProps?: InputLabelProps;
  };

type Props = DatePickerProps;

class DatePicker extends Component<Props> {
  static defaultProps: Partial<DatePickerProps> = {
    withLabel: true
  };

  render() {
    const {
      label,
      placeholder,
      withTime,
      dateFormat: dateFormatProp,
      withLabel,
      helperText,
      InputLabelProps = {},
      ...rest
    } = this.props;

    const formControlPropKeys: Array<any> = [
      "component",
      "disabled",
      "error",
      "fullWidth",
      "margin",
      "onBlur",
      "onFocus",
      "required"
    ];

    const formControlProps = pick(
      rest,
      ...formControlPropKeys
    ) as any as Partial<FormControlProps>;
    const placeholderText = placeholder;

    const df = moment.localeData().longDateFormat("L");
    const tf = moment.localeData().longDateFormat("LT");

    const dateFormat = dateFormatProp
      ? dateFormatProp
      : rest.showTimeSelect
      ? `${df} ${tf}`
      : df;

    return (
      <FormControl {...formControlProps}>
        {withLabel && label && <InputLabel {...InputLabelProps}>{label}</InputLabel>}

        <ReactDatePicker
          disabled={this.props.disabled}
          dateFormat={dateFormat}
          placeholderText={placeholderText}
          timeFormat={moment.localeData().longDateFormat("LT")}
          inputFieldProps={{ style: { marginTop: withLabel ? 16 : "inherit" } }}
          showWeekNumbers
          {...rest}
        />

        {helperText && (
          <FormHelperText style={{ color: "black" }}>{helperText}</FormHelperText>
        )}
      </FormControl>
    );
  }
}

export default DatePicker;
